export const CONTAINER_CLASS =
    " my-5 md:my-10 py-5 md:py-10 px-6 md:px-12  bg-Secondary_Background ";
export const INNER_CONTAINER = "w-full grid place-content-end ";
export const QOUTES_CLASS = "h-[23px] md:h-[48px] w-auto";
